<template>
  <div>
    <v-container>
      <v-row v-if="isAdminUser">
        <v-col>
          <v-text-field
            label="TaxRuleId"
            v-model="taxRuleId"
            solo
            clearable
            prepend-icon="mdi-magnify"
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="TaxJurisdictionID"
            v-model="taxJurisdictionID"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Country"
            v-model="country"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="TaxGroupId"
            v-model="taxGroupId"
            solo
            clearable
            @input="syncFiltered()"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-switch
            v-model="showDeleted"
            label="Show deleted"
            @change="syncFiltered()"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <h4 class="text-danger">The Posdata repository for taxes is not available anymore. If needed, please contact the Taxes or masterdata team.</h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-if="isAdminUser">
      <v-data-table
        :headers="headers"
        :items="taxesFiltered"
        :loading="isLoading"
        class="elevation-10"
        loading-text="Loading... Please wait"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" v-if="isAdminUser" @click="edit(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import { parameters } from "../../parameters";
import { httpClient, authState } from "../../requesters/httpClient";
import { USER_ROLE } from "../../requesters/userConstants";
import router from "../../router";

export default {
  name: "Taxes",
  data() {
    return {
      taxes: [],
      taxesFiltered: [],
      taxRuleId: "",
      taxGroupId: "",
      country: "",
      taxJurisdictionID: "",
      showDeleted: false,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Tax Jurisdiction ID", value: "taxJurisdictionID" },
        { text: "Tax Jurisdiction Code", value: "taxJurisdictionCode" },
        { text: "Tax Jurisdiction Name", value: "taxJurisdictionName" },
        { text: "Country", value: "country" },
        { text: "Tax Rule ID", value: "taxRuleID" },
        { text: "Tax Group ID", value: "taxGroupID" },
        { text: "Tax Rate", value: "taxRate" },
        { text: "Tax Type", value: "taxType" },
        { text: "Tax Sub Type", value: "taxSubType" },
        { text: "Tax Name", value: "taxName" },
        { text: "Effective Date", value: "effectiveDate" },
        { text: "Expiration Date", value: "expirationDate" },
        { text: "Is Deprecated", value: "deprecated" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      isLoading: false,
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    this.isLoading = true;
    await httpClient
      .get(`${parameters.posdataRefUrl}/taxes`)
      .then((response) => {
        this.taxes = response.data;
        this.syncFiltered();
        this.isLoading = false;
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    syncFiltered() {
      this.taxesFiltered = new Array();
      this.taxes.forEach((tax) => {
        if (
          this.isCountryCode(tax) &&
          this.isTaxJurisdictionId(tax) &&
          this.isTaxRuleIdFiltered(tax) &&
          this.isTaxGroupIdFiltered(tax) &&
          this.isDeleted(tax)
        ) {
          this.taxesFiltered.push(tax);
        }
      });
    },

    isTaxRuleIdFiltered: function (tax) {
      return (
        this.taxRuleId === null ||
        this.taxRuleId === "" ||
        this.taxRuleId === tax.taxRuleID
      );
    },
    isTaxGroupIdFiltered: function (tax) {
      return (
        this.taxGroupId === null ||
        this.taxGroupId === "" ||
        this.taxGroupId === tax.taxGroupID
      );
    },
    isCountryCode: function (tax) {
      return (
        this.country === null ||
        this.country === "" ||
        this.country === tax.country
      );
    },
    isTaxJurisdictionId: function (tax) {
      return (
        this.taxJurisdictionID === null ||
        this.taxJurisdictionID === "" ||
        this.taxJurisdictionID === tax.taxJurisdictionID
      );
    },
    isDeleted: function (tax) {
      return !this.showDeleted
        ? Date.parse(tax.expirationDate) > Date.now()
        : true;
    },
    edit: function (item) {
      router.push({
        path: "editTax",
        query: { id: item.id },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/taxes/Taxes.vue